import PocketBase from 'pocketbase';

// Configuration PocketBase
const pb = new PocketBase('https://christophedepanne.infocolab.online');

// Désactiver l'auto-cancel pour éviter les erreurs de requêtes simultanées
pb.autoCancellation(false);

export default pb;
